import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "repaginateoption"
    }}>{`RepaginateOption`}</h1>
    <p>{`Page numbering options for book content objects within the book.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NEXT_PAGE`}</strong>{` = 1885500011`}</p>
      <p parentName="blockquote">{`Continues page numbers sequentially from the previous book content object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NEXT_ODD_PAGE`}</strong>{` = 1332765291`}</p>
      <p parentName="blockquote">{`Starts page numbers for each book content object at the next odd-numbered page after the last page of the previous book content object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NEXT_EVEN_PAGE`}</strong>{` = 1164993131`}</p>
      <p parentName="blockquote">{`Starts page numbers for each book content object at the next even-numbered page after the last page of the previous book content object.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      